function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'lodash/omit';
import mapKeys from 'lodash/mapKeys';
import { combineReducers } from 'redux';
import { GET_USER_TOKEN, GET_FAVORITE_SPOTS, CREATE_FAVORITE_SPOT, DELETE_FAVORITE_SPOT, SAVE_FAVORITE_SPOT_ID, SET_API_PARAMS, AUTH_WINDOW } from '../actions/types';

function favoriteSpotReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_FAVORITE_SPOTS:
      return _objectSpread({}, state, {}, mapKeys(action.payload, 'id'));

    case CREATE_FAVORITE_SPOT:
      return _objectSpread({}, state, _defineProperty({}, action.payload.id, action.payload));

    case DELETE_FAVORITE_SPOT:
      return omit(state, action.payload);

    default:
      return state;
  }
}

function favoriteSpotIdsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SAVE_FAVORITE_SPOT_ID:
      return [].concat(_toConsumableArray(state), [action.payload]).flat();

    default:
      return state;
  }
}

function userTokenReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_USER_TOKEN:
      return action.payload;

    default:
      return state;
  }
}

function apiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_API_PARAMS:
      return action.payload;

    default:
      return state;
  }
}

function authWindowReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case AUTH_WINDOW:
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  userToken: userTokenReducer,
  favoriteSpots: favoriteSpotReducer,
  favoriteSpotIds: favoriteSpotIdsReducer,
  api: apiReducer,
  authWindow: authWindowReducer
});